export default "__VITE_ASSET__Cbygq9qh__"